/**
 * One device in an unfolded list.
 *
 * `role="option"` rather than a plain button, because the list around it is a
 * listbox and the fold above it is the combobox: a screen reader has to be able
 * to say "3 of 7, selected", which a row of buttons cannot express.
 */
import { Check } from "lucide-react";
import { cn } from "@wa/ui";

export function DeviceRow({
  label,
  chosen,
  onPick,
}: {
  label: string;
  chosen: boolean;
  onPick: () => void;
}) {
  return (
    <button
      type="button"
      role="option"
      aria-selected={chosen}
      className={cn("crm-mi", chosen && "is-on")}
      onClick={onPick}
    >
      {/* An outer box that clips and an inner line that slides (`.crm-mq`).
          At rest it is exactly the ellipsis it used to be; resting the pointer
          on the row reads the name out to its end. That is not decoration here:
          the rail gives this list 188px, which is about twenty characters, and
          two headsets from the same maker are identical for the first nineteen.
          `flex-1` is what makes the container query safe - the width comes from
          the row, never from the text. */}
      <span className="crm-mq min-w-0 flex-1">
        <span>{label}</span>
      </span>
      {chosen ? <Check className="size-4 shrink-0" /> : null}
    </button>
  );
}
